export default defineNuxtPlugin(() => {
  // Force full page reload on navigation
  // This is a temporary solution until we fix client-side navigation
  
  if (process.client) {
    // Inside the Page Builder canvas the bridge owns click handling (block selection);
    // a forced reload here would navigate the iframe away mid-edit. This plugin's capture
    // listener registers BEFORE the bridge's (plugins load alphabetically), so it must bail.
    if (new URLSearchParams(window.location.search).get('pb-builder') === '1') {
      return
    }

    // Intercept all link clicks and force full page reload
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      const link = target.closest('a[href]') as HTMLAnchorElement
      
      if (!link) return

      // Respect new-tab / download links
      if (link.target === '_blank' || link.hasAttribute('download')) return
      
      const href = link.getAttribute('href')
      if (!href) return
      
      // Skip external links and anchors
      if (href.startsWith('http') || href.startsWith('//') || href.startsWith('#')) {
        return
      }
      
      // Skip if it's the same page
      if (href === window.location.pathname) {
        return
      }
      
      // Prevent default navigation and force full reload
      e.preventDefault()
      window.location.href = href
    }, true) // Use capture phase to intercept early
  }
})